import { Chip } from '@/components/UI/Chip'
import { ITableColumn } from '@/components/UI/DataTable/TableHead'
import { IManualIncome } from '@/types'
import { formatDate } from '@/utils/common'
import { cell } from '../cell'
import { formatDay, formatDollars, formatEnum } from '../format'
import { MANUAL_INCOME_STATUS_COLOUR, MANUAL_INCOME_STATUS_LABEL } from './status'

const dateTime = (value?: string) => (value ? formatDate(value, false, true) : '')

export const manualPayCycleColumns: ITableColumn<IManualIncome>[] = [
  {
    key: 'status',
    id: 'status',
    label: 'Status',
    minWidth: '140px',
    render: (_v, r) => (
      <Chip
        value={MANUAL_INCOME_STATUS_LABEL[r.status]}
        chipColor={MANUAL_INCOME_STATUS_COLOUR[r.status]}
      />
    ),
  },
  {
    key: 'lastPaidAmount',
    id: 'lastPaidAmount',
    label: 'Last Paid Amount',
    align: 'right',
    // int64 cents on the wire.
    render: (_v, r) => cell(formatDollars(r.lastPaidAmount / 100)),
  },
  {
    key: 'lastPayDay',
    id: 'lastPayDay',
    label: 'Last Pay Day',
    minWidth: '120px',
    render: (_v, r) => cell(formatDay(r.lastPayDay)),
  },
  {
    key: 'recurringFrequency',
    id: 'recurringFrequency',
    label: 'Frequency',
    render: (_v, r) => cell(formatEnum(r.recurringFrequency)),
  },
  {
    key: 'bankAccountId',
    id: 'bankAccountId',
    label: 'Bank Account Id',
    render: (_v, r) => cell(r.bankAccountId),
  },
  { key: 'id', id: 'id', label: 'Request Id', render: (_v, r) => cell(r.id) },
  {
    key: 'createdAt',
    id: 'createdAt',
    label: 'Submitted At',
    minWidth: '170px',
    render: (_v, r) => cell(dateTime(r.createdAt)),
  },
  {
    key: 'updatedAt',
    id: 'updatedAt',
    label: 'Reviewed At',
    minWidth: '170px',
    // updated_at is only a review time once the request has left PENDING.
    render: (_v, r) => cell(r.status !== 'PENDING' ? dateTime(r.updatedAt) : ''),
  },
]
